/**
 * A run that one of its generated tools stopped with its own reason, e.g. a
 * workbook without the sheet the tool reads. mission-runner decides this and
 * ends the run with outcome tool_reported_error and the tool's reason as the
 * run's error, live on mission.failed and in the mission_ended history event.
 * Chat shows that reason in a warning with what to do, not the crash line.
 */
export const TOOL_REPORTED_ERROR_OUTCOME = 'tool_reported_error'

/** The tool's reason when the run ended with outcome tool_reported_error, else undefined. */
export function toolReportedReason(outcome: unknown, error: unknown): string | undefined {
  if (outcome !== TOOL_REPORTED_ERROR_OUTCOME || typeof error !== 'string') return undefined
  return error.trim() || undefined
}
